// extracted by mini-css-extract-plugin
module.exports = {"checkboxAftertit":"cn_checkboxAftertit__32iC-"};